

/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";
// customerRegister
// CUSTOMERREGISTER
const GETEMPLOYEEDASHBOARDBYYEAR= createAsyncThunk(
  "getEmployeeDashboardByYear/getEmployeeDashboardByYear",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const getEmployeeDashboardByYearSlice = createSlice({
  name: "getEmployeeDashboardByYearSlice",
  initialState: {
    getEmployeeDashboardByYear: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfgetEmployeeDashboardByYear: (state) => {
        state.getEmployeeDashboardByYear.loading = false
        state.getEmployeeDashboardByYear.error = false
        state.getEmployeeDashboardByYear.data = []
        state.getEmployeeDashboardByYear.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(GETEMPLOYEEDASHBOARDBYYEAR.fulfilled, (state, action) => {
      state.getEmployeeDashboardByYear = {
        ...state.getEmployeeDashboardByYear,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETEMPLOYEEDASHBOARDBYYEAR.pending, (state, action) => {
      state.getEmployeeDashboardByYear = {
        ...state.getEmployeeDashboardByYear,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETEMPLOYEEDASHBOARDBYYEAR.rejected, (state, action) => {
      state.getEmployeeDashboardByYear = {
        ...state.getEmployeeDashboardByYear,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const getEmployeeDashboardByYearAction = {
    GETEMPLOYEEDASHBOARDBYYEAR,
};

export { getEmployeeDashboardByYearAction };
export default getEmployeeDashboardByYearSlice.reducer;
export const {setInitialStateOfgetEmployeeDashboardByYear} = getEmployeeDashboardByYearSlice.actions
